export const itemCategories = ['jobs', 'contractors'];
export const itemCategoryAliases = { 'j': 'jobs', 'c': 'contractors' };